import {Injectable} from '@angular/core';
import AppConstant from '../../constants/app.constant';
import appUtil from '../../util/app.util';
import {AppStorageService} from '../storage/app-storage.service';
import {AppEnum} from '../../constants/app.enum';

@Injectable({
  providedIn: 'root',
})
export class AppPrincipalService {
  constructor(private readonly storageService: AppStorageService) {}

  getToken(): string {
    return this.storageService.getItem(AppConstant.STORAGE_KEYS.SIT_T) as string;
  }

  getRefToken(): string {
    return this.storageService.getItem(AppConstant.STORAGE_KEYS.SIT_R_T) as string;
  }

  getMspin(): string {
    return this.storageService.getItem(AppConstant.STORAGE_KEYS.SIT_D_MSPIN) as string;
  }

  isUserAuthenticated(): boolean {
    return !appUtil.isEmpty(this.getToken()) && !appUtil.isEmpty(this.getRefToken());
  }

  isDealer(): boolean {
    if (appUtil.isEmpty(this.getToken())) {
      return false;
    }
    return true;
  }

  getCustomerToken(): string {
    return this.storageService.getItem(AppConstant.STORAGE_KEYS.SIT_CUST_T) as string;
  }

  getChannel(): string {
    const theme = this.storageService.getItem('theme') as string;
    return theme === AppEnum.APP_CHANNEL_ARENA
      ? AppEnum.APP_CHANNEL_ARENA_VAL
      : AppEnum.APP_CHANNEL_NEXA_VAL;
  }

  isDealerLoggedIn(): boolean {
    return !appUtil.isEmpty(this.getToken()) && !appUtil.isEmpty(this.getMspin());
  }
}
